import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { CompanyOwned } from './company-models.model';

@HateoasResource('document')
export class FileDocument extends CompanyOwned {
  public naam!: string;
  public uniekecode!: string;
  public content!: string;
  public inhoudtype!: string;
  public omschrijving!: string;
  public _attachments: any;
}
